import logo from './logo.svg';
import './App.css';
import './Components/styles/footer.css';
import Home from './Components/pages/home';
import Solution from './Components/pages/Solutions';
import About from './Components/pages/about';
import Product from './Components/pages/product';
import Careers from './Components/pages/careers';
import Team from './Components/pages/team';
import Contact from './Components/pages/contact';
import Blog from './Components/pages/blog';
import Footer from './Components/footer';
import Navbar from './Components/navbar';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import "font-awesome/css/font-awesome.min.css";







function App() {
  return (
    <div className="App">

      <Router>
        <Navbar />


        <Routes > <Route path="/" element={<Home />} />
         <Route path="/home" element={<Home />} />
          <Route path="/Solution" element={<Solution />} />
          <Route path="/about" element={<About />} />
          <Route path="/product" element={<Product />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/team" element={<Team />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} /> 
        </Routes>
        <Footer />


      </Router>

    </div>
  );
}

export default App;
